<div class="wizard-overlay"></div>

<div class="wizard-shell">
  <app-embedded-loader
    class="wizard-inline-loader"
    [show]="tabSwitching || loading || saving"
    [message]="
      loading ? 'Loading your KYC...' :
      saving ? 'Submitting your KYC...' :
      'Saving your changes...'
    "
  ></app-embedded-loader>
  <!-- Top action bar -->
  <div class="wizard-topbar">
    <div class="wizard-ref" *ngIf="kycReference">
      <span class="ref-label">Reference</span>
      <span class="ref-value">{{ kycReference }}</span>
    </div>
    <div class="wizard-top-actions">
      <!-- <button
        class="btn btn-outline"
        [disabled]="readOnly"
        (click)="saveAsDraft()"
      >
        <mat-icon>save</mat-icon>
        Save as Draft
      </button> -->
      <button
        *ngIf="activeTab === 'preview'"
        class="btn btn-primary"
        [disabled]="readOnly"
        (click)="submitKyc()"
      >
        <mat-icon>send</mat-icon>
        Submit KYC
      </button>
      <!-- <button class="btn btn-close" (click)="onClose()">
        <mat-icon>cancel</mat-icon>
        Close
      </button> -->
    </div>
  </div>

  <!-- Admin feedback banner -->
  <div
    *ngIf="adminBannerKind"
    class="kyc-admin-banner"
    [class.kyc-admin-banner--clarify]="adminBannerKind === 'CLARIFICATION'"
    [class.kyc-admin-banner--reject]="adminBannerKind === 'REJECTED'"
    [class.kyc-admin-banner--approved]="adminBannerKind === 'APPROVED'"
  >
    <mat-icon class="kyc-admin-banner-icon">
      {{
        adminBannerKind === 'APPROVED'
          ? 'verified'
          : adminBannerKind === 'REJECTED'
          ? 'cancel'
          : 'contact_support'
      }}
    </mat-icon>
    <div class="kyc-admin-banner-body">
      <div class="kyc-admin-banner-title">
        {{
          adminBannerKind === 'APPROVED'
            ? 'KYC approved by admin'
            : adminBannerKind === 'REJECTED'
            ? 'KYC submission rejected'
            : 'Clarification requested by admin'
        }}
      </div>
      <div class="kyc-admin-banner-msg" *ngIf="adminBannerMessage">
        {{ adminBannerMessage }}
      </div>
      <div class="kyc-admin-banner-msg" *ngIf="!adminBannerMessage && adminBannerKind === 'APPROVED'">
        Your KYC application has been verified. No further action required.
      </div>
    </div>
  </div>

  <!-- Tabs -->
  <div class="wizard-tabs">
    <div
      *ngFor="let tab of tabs"
      class="wizard-tab"
      [class.active]="activeTab === tab.key"
      (click)="switchTab(tab.key)"
    >
      <mat-icon>{{ tab.icon }}</mat-icon>
      <span>{{ tab.label }}</span>
      <mat-icon
        class="tab-status"
        *ngIf="tab.key === 'org' && isOrgComplete()"
        >check_circle</mat-icon
      >
      <mat-icon
        class="tab-status"
        *ngIf="tab.key === 'docs' && isDocsComplete()"
        >check_circle</mat-icon
      >
      <mat-icon
        class="tab-status"
        *ngIf="tab.key === 'bank' && isBankComplete()"
        >check_circle</mat-icon
      >
    </div>
  </div>

  <!-- Body -->
  <div class="wizard-body">
    <!-- ============ ORGANIZATIONAL DATA ============ -->
    <div class="tab-panel" *ngIf="activeTab === 'org'">
      <div class="panel-title">
        <mat-icon class="panel-icon">business</mat-icon>
        Organization Details
      </div>

      <form [formGroup]="orgForm" class="form-grid">
        <div class="form-field">
          <label>Organization Name <span class="req">*</span></label>
          <input
            type="text"
            formControlName="organizationName"
            placeholder="Enter organization name"
          />
          <small
            class="error"
            *ngIf="
              orgForm.get('organizationName')?.touched &&
              orgForm.get('organizationName')?.invalid
            "
            >Organization name is required.</small
          >
        </div>

        <div class="form-field">
          <label>Business Type <span class="req">*</span></label>
          <select formControlName="businessTypeId">
            <option value="" disabled>Select business type</option>
            <option *ngFor="let type of businessTypes" [ngValue]="type.id">
              {{ type.displayName }}
            </option>
          </select>
          <small
            class="error"
            *ngIf="
              orgForm.get('businessTypeId')?.touched &&
              orgForm.get('businessTypeId')?.invalid
            "
            >Business type is required.</small
          >
        </div>

        <div class="form-field full-row" formGroupName="registeredAddress">
          <label>Registered Address <span class="req">*</span></label>
          <div class="address-grid">
            <input
              class="addr-street"
              formControlName="street"
              placeholder="Street / building / area"
            />
            <input formControlName="city" placeholder="City" />
            <input formControlName="region" placeholder="Region / State" />
            <input formControlName="country" placeholder="Country" />
            <input formControlName="zipcode" placeholder="Pincode / ZIP" />
          </div>
          <small
            class="error"
            *ngIf="
              orgForm.get('registeredAddress')?.touched &&
              orgForm.get('registeredAddress')?.invalid
            "
            >Street, city, country and pincode are required.</small
          >
        </div>

        <div class="form-field full-row" formGroupName="tradingAddress">
          <label>Trading Address</label>
          <div class="address-grid">
            <input
              class="addr-street"
              formControlName="street"
              placeholder="Street / building / area (if different)"
            />
            <input formControlName="city" placeholder="City" />
            <input formControlName="region" placeholder="Region / State" />
            <input formControlName="country" placeholder="Country" />
            <input formControlName="zipcode" placeholder="Pincode / ZIP" />
          </div>
        </div>

        <div class="form-field full-row">
          <label>Company Logo</label>
          <div class="logo-row">
            <label class="logo-upload-btn">
              <mat-icon>upload</mat-icon>
              Upload Logo
              <input
                type="file"
                accept="image/png,image/jpeg"
                (change)="onLogoSelected($event)"
                hidden
              />
            </label>
            <span class="logo-hint">
              Accepted formats: PNG, JPEG (Max 2MB)
            </span>
            <div class="logo-preview" *ngIf="logoPreview">
              <img [src]="logoPreview" alt="Logo preview" />
              <span class="logo-name">{{ logoFileName }}</span>
              <button class="logo-remove" (click)="removeLogo()" type="button">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </form>

      <div class="panel-divider"></div>

      <div class="panel-title">
        <mat-icon class="panel-icon">mail</mat-icon>
        Contact Information
      </div>

      <form [formGroup]="orgForm" class="form-grid">
        <div class="form-field">
          <label>Email Address <span class="req">*</span></label>
          <div class="input-with-icon">
            <mat-icon>lock</mat-icon>
            <input
              type="email"
              formControlName="email"
              placeholder="contact@company.com"
              readonly
            />
          </div>
          <small class="hint">This is your login email and cannot be changed.</small>
        </div>

        <div class="form-field">
          <label>Phone Number <span class="req">*</span></label>
          <div class="input-with-icon">
            <mat-icon>phone</mat-icon>
            <input
              type="tel"
              formControlName="phone"
              placeholder="+1 (555) 000-0000"
            />
          </div>
          <small
            class="error"
            *ngIf="orgForm.get('phone')?.touched && orgForm.get('phone')?.invalid"
            >Enter a valid phone number.</small
          >
        </div>

        <div class="form-field">
          <label>Website</label>
          <div class="input-with-icon">
            <mat-icon>language</mat-icon>
            <input
              type="text"
              formControlName="website"
              placeholder="https://www.company.com"
            />
          </div>
          <small
            class="error"
            *ngIf="
              orgForm.get('website')?.touched &&
              orgForm.get('website')?.errors?.['invalidUrl']
            "
            >Enter a valid URL.</small
          >
        </div>

        <!-- =====================================================
             MPS-263 KYC-101 — company identifiers
             Author: Akarsh Singh | 2026-08-31

             The same block the portal wizard shows. A supplier invited by PO
             token faces the same submit gate, so they are asked the same
             questions, from the same country config.
             ===================================================== -->
        <div class="form-field">
          <label>Country of Incorporation <span class="req">*</span></label>
          <select
            formControlName="countryOfIncorporationId"
            (change)="onCountryChange(orgForm.get('countryOfIncorporationId')?.value)"
          >
            <option [ngValue]="null">Select the country your company is registered in</option>
            <option *ngFor="let c of countryList" [ngValue]="c.id">{{ c.name }}</option>
          </select>
          <small
            class="error"
            *ngIf="
              orgForm.get('countryOfIncorporationId')?.touched &&
              orgForm.get('countryOfIncorporationId')?.invalid
            "
            >Select the country your company is incorporated in.</small
          >
        </div>

        <div class="form-field" *ngFor="let field of identifierFields">
          <label>
            {{ field.label }}
            <span class="req" *ngIf="field.required">*</span>
          </label>
          <select
            *ngIf="field.type === 'SELECT'"
            [(ngModel)]="identifierValues[field.key]"
            [ngModelOptions]="{ standalone: true }"
            (blur)="onIdentifierBlur(field.key)"
          >
            <option value="">Select {{ field.label }}</option>
            <option *ngFor="let opt of field.options" [value]="opt">{{ opt }}</option>
          </select>
          <input
            *ngIf="field.type !== 'SELECT'"
            type="text"
            [(ngModel)]="identifierValues[field.key]"
            [ngModelOptions]="{ standalone: true }"
            (blur)="onIdentifierBlur(field.key)"
            [placeholder]="'Enter ' + field.label"
          />
          <small class="error" *ngIf="identifierErrors[field.key]">
            {{ identifierErrors[field.key] }}
          </small>
          <small class="hint" *ngIf="field.hint && !identifierErrors[field.key]">
            {{ field.hint }}
          </small>
        </div>
      </form>
    </div>

    <!-- ============ KYC DOCUMENTS ============ -->
    <div class="tab-panel" *ngIf="activeTab === 'docs'">
      <div class="panel-title-row">
        <div class="panel-title">
          <mat-icon class="panel-icon">description</mat-icon>
          KYC Documents
        </div>
        <button class="btn btn-primary" (click)="addExtraDoc()">
          <mat-icon>add</mat-icon>
          Add Document
        </button>
      </div>

      <div class="docs-grid">
        <div class="doc-slot" *ngFor="let doc of documents">
          <div class="doc-slot-label">
            {{ doc.label }}
            <span class="req" *ngIf="doc.required">*</span>
          </div>

          <!-- MPS-263 KYC-103 — the declaration has to be made on our form. -->
          <button type="button" class="doc-template-link"
                  *ngIf="doc.code === 'UBO_DECLARATION'"
                  (click)="downloadUboTemplate()">
            <mat-icon>download</mat-icon>
            <span>Download the declaration form</span>
          </button>

          <div class="doc-slot-hint" *ngIf="slotTakesManyFiles(doc)">
            One ID copy per owner listed in Table A. Add them one at a time —
            each upload is kept.
          </div>

          <ul class="doc-multi-list" *ngIf="doc.moreFiles?.length">
            <li *ngFor="let f of doc.moreFiles">
              <mat-icon>check_circle</mat-icon><span>{{ f.fileName }}</span>
            </li>
          </ul>
          <div
            class="doc-dropzone"
            (drop)="onDocDropped($event, doc)"
            (dragover)="onDocDragOver($event)"
            [class.has-file]="doc.fileUrl || doc.pendingFile"
            [class.pending]="doc.pendingFile && !doc.fileUrl"
          >
            <ng-container *ngIf="!doc.fileName">
              <mat-icon>upload</mat-icon>
              <div class="dropzone-text">
                Drag &amp; drop or
                <label class="browse-link">
                  browse
                  <input
                    type="file"
                    accept="application/pdf,image/jpeg,image/png"
                    (change)="onDocSelected($event, doc)"
                    hidden
                  />
                </label>
              </div>
              <div class="dropzone-hint">PDF, JPEG, PNG (Max 10MB)</div>
            </ng-container>
            <ng-container *ngIf="doc.fileName">
              <div class="file-pill">
                <mat-icon>{{ doc.pendingFile && !doc.fileUrl ? 'pending' : 'insert_drive_file' }}</mat-icon>
                <div class="file-info">
                  <div class="file-name" *ngIf="!doc.fileUrl">{{ doc.fileName }}</div>
                  <div class="file-name file-link" *ngIf="doc.fileUrl" (click)="viewFile(doc.fileUrl)">{{ doc.fileName }}</div>
                  <div class="file-size">
                    {{ formatFileSize(doc.fileSize) }}
                    <span class="pending-tag" *ngIf="doc.pendingFile && !doc.fileUrl"> · pending upload</span>
                  </div>
                </div>
                <button class="file-action" *ngIf="doc.fileUrl" (click)="viewFile(doc.fileUrl)" matTooltip="View" type="button">
                  <mat-icon>visibility</mat-icon>
                </button>
                <button class="file-remove" (click)="removeDoc(doc)" *ngIf="!readOnly" type="button">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <!-- Extra documents -->
      <div *ngIf="extraDocs.length > 0" class="extra-docs-section">
        <div class="panel-subtitle">Additional Documents</div>
        <div class="extra-doc-row" *ngFor="let doc of extraDocs; let i = index">
          <input
            type="text"
            class="extra-doc-name"
            [(ngModel)]="doc.name"
            placeholder="Document name"
          />
          <label class="btn btn-outline btn-sm">
            <mat-icon>upload</mat-icon>
            <span *ngIf="!doc.fileName">Upload</span>
            <span *ngIf="doc.fileName">{{ doc.fileName }}</span>
            <input
              type="file"
              accept="application/pdf,image/jpeg,image/png"
              (change)="onExtraDocFileSelected($event, doc)"
              hidden
            />
          </label>
          <button class="icon-btn" (click)="removeExtraDoc(i)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>

      <div class="panel-divider"></div>

      <div class="panel-title">
        <mat-icon class="panel-icon">workspace_premium</mat-icon>
        ISO &amp; Marine quality certifications
      </div>

      <div class="cert-list">
        <div class="cert-row" *ngFor="let cert of certifications">
          <div class="cert-icon"><mat-icon>{{ cert.iconCode }}</mat-icon></div>
          <div class="cert-meta">
            <div class="cert-title">{{ cert.title }}</div>
            <div class="cert-subtitle">{{ cert.subtitle }}</div>
            <div class="cert-file-tag" *ngIf="cert.fileName">
              <mat-icon class="cert-file-icon">insert_drive_file</mat-icon>
              <span class="cert-file-name" *ngIf="!cert.fileUrl">{{ cert.fileName }} (pending)</span>
              <span class="cert-file-name file-link" *ngIf="cert.fileUrl" (click)="viewFile(cert.fileUrl)">{{ cert.fileName }}</span>
              <span class="cert-file-size">{{ formatFileSize(cert.fileSize) }}</span>
            </div>
          </div>
          <div
            class="cert-toggle"
            [class.on]="cert.isEnabled"
            (click)="toggleCertification(cert)"
          >
            <span class="toggle-knob"></span>
          </div>
          <button
            class="cert-view"
            *ngIf="cert.fileUrl"
            (click)="viewFile(cert.fileUrl)"
            matTooltip="View uploaded file"
            type="button"
          >
            <mat-icon>visibility</mat-icon>
          </button>
          <label class="cert-upload" [class.disabled]="!cert.isEnabled || readOnly">
            <mat-icon>upload</mat-icon>
            <input
              type="file"
              accept="application/pdf,image/jpeg,image/png"
              [disabled]="!cert.isEnabled || readOnly"
              (change)="onCertFileSelected($event, cert)"
              hidden
            />
          </label>
        </div>
      </div>
    </div>

    <!-- ============ BANKING INFORMATION ============ -->
    <div class="tab-panel" *ngIf="activeTab === 'bank'">
      <div class="panel-title">
        <mat-icon class="panel-icon">account_balance</mat-icon>
        Banking Information
      </div>

      <div class="alert alert-warning">
        <mat-icon>warning</mat-icon>
        <div>
          <strong>Important:</strong> The account holder name must exactly
          match your organization's legal name as registered.
        </div>
      </div>

      <form [formGroup]="bankForm" class="form-grid">
        <div class="form-field full-row">
          <label>Account Holder Name <span class="req">*</span></label>
          <input
            type="text"
            formControlName="accountHolderName"
            placeholder="Enter account holder name (as per bank records)"
          />
          <small
            class="error"
            *ngIf="
              bankForm.get('accountHolderName')?.touched &&
              bankForm.get('accountHolderName')?.invalid
            "
            >Account holder name is required.</small
          >
        </div>

        <div class="form-field">
          <label>Bank Account Number <span class="req">*</span></label>
          <div class="bank-account-input">
            <input
              [type]="showBankAccountNumber ? 'text' : 'password'"
              formControlName="accountNumber"
              placeholder="Enter account number"
            />
            <button
              type="button"
              class="bank-account-view-btn"
              (click)="showBankAccountNumber = !showBankAccountNumber"
              [attr.aria-label]="showBankAccountNumber ? 'Hide bank account number' : 'View bank account number'"
              [matTooltip]="showBankAccountNumber ? 'Hide account number' : 'View account number'"
            >
              <mat-icon>{{ showBankAccountNumber ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </div>
          <small
            class="error"
            *ngIf="
              bankForm.get('accountNumber')?.touched &&
              bankForm.get('accountNumber')?.invalid
            "
            >Account number is required.</small
          >
        </div>

        <div class="form-field">
          <label>Confirm Account Number <span class="req">*</span></label>
          <input
            type="text"
            formControlName="confirmAccountNumber"
            placeholder="Re-enter account number"
          />
          <small
            class="error"
            *ngIf="
              bankForm.get('confirmAccountNumber')?.touched &&
              (bankForm.get('confirmAccountNumber')?.invalid ||
                bankForm.errors?.['accountNumberMismatch'])
            "
          >
            <ng-container
              *ngIf="bankForm.errors?.['accountNumberMismatch']; else reqMsg"
              >Account numbers do not match.</ng-container
            >
            <ng-template #reqMsg>Please confirm your account number.</ng-template>
          </small>
        </div>

        <div class="form-field">
          <label>IFSC / SWIFT Code <span class="req">*</span></label>
          <input
            type="text"
            formControlName="ifscSwift"
            placeholder="ENTER IFSC OR SWIFT CODE"
            style="text-transform: uppercase"
          />
          <small
            class="error"
            *ngIf="
              bankForm.get('ifscSwift')?.touched &&
              bankForm.get('ifscSwift')?.invalid
            "
            >IFSC / SWIFT code is required.</small
          >
        </div>

        <!-- MPS-263 KYC-102 — the bank in words, for the admin's comparison. -->
        <div class="form-field">
          <label>Bank Name <span class="req">*</span></label>
          <input type="text" formControlName="bankName"
                 placeholder="Name of the bank holding this account" />
          <small class="error"
            *ngIf="bankForm.get('bankName')?.touched && bankForm.get('bankName')?.invalid"
            >Bank name is required.</small>
        </div>

        <div class="form-field">
          <label>Branch <span class="req">*</span></label>
          <input type="text" formControlName="branchName"
                 placeholder="Branch the account is held at" />
          <small class="error"
            *ngIf="bankForm.get('branchName')?.touched && bankForm.get('branchName')?.invalid"
            >Branch is required.</small>
        </div>

        <div class="form-field">
          <label>Bank Account Type <span class="req">*</span></label>
          <select formControlName="accountTypeId">
            <option value="" disabled>Select account type</option>
            <option *ngFor="let t of bankAccountTypes" [ngValue]="t.id">
              {{ t.displayName }}
            </option>
          </select>
          <small
            class="error"
            *ngIf="
              bankForm.get('accountTypeId')?.touched &&
              bankForm.get('accountTypeId')?.invalid
            "
            >Account type is required.</small
          >
        </div>
      </form>

      <div class="info-box">
        <div class="info-title">Additional Information</div>
        <ul>
          <li>Ensure all bank details are accurate to avoid payment delays</li>
          <li>The account must be in the name of the registered organization</li>
          <li>
            You may be required to provide a cancelled cheque or bank statement
            for verification
          </li>
        </ul>
      </div>
    </div>

    <!-- ============ PREVIEW & SUBMIT ============ -->
    <div class="tab-panel" *ngIf="activeTab === 'preview'">
      <div class="panel-title">Review Your Information</div>
      <div class="panel-subtitle">
        Please review all information before submitting your KYC application
      </div>

      <div class="alert alert-danger" *ngIf="getMissingDocs().length > 0">
        <mat-icon>error</mat-icon>
        <div>
          <strong>Missing Required Documents</strong>
          <div>
            The following required documents are missing:
            {{ getMissingDocs().join(', ') }}
          </div>
        </div>
      </div>

      <div class="alert alert-danger" *ngIf="!isOrgComplete()">
        <mat-icon>error</mat-icon>
        <div>
          <strong>Organization details incomplete</strong>
          <div>Please complete all required fields in Organizational Data.</div>
        </div>
      </div>

      <div class="alert alert-danger" *ngIf="!isBankComplete()">
        <mat-icon>error</mat-icon>
        <div>
          <strong>Banking information incomplete</strong>
          <div>Please complete all required fields in Banking Information.</div>
        </div>
      </div>

      <div class="preview-card">
        <div class="preview-card-title">
          <mat-icon>business</mat-icon>
          Organization Details
        </div>
        <div class="preview-grid">
          <div class="preview-field">
            <div class="preview-label">Organization Name</div>
            <div class="preview-value">
              {{ orgForm.get('organizationName')?.value || '-' }}
            </div>
          </div>
          <div class="preview-field">
            <div class="preview-label">Business Type</div>
            <div class="preview-value">
              {{ businessTypeName(orgForm.get('businessTypeId')?.value) }}
            </div>
          </div>
          <div class="preview-field full-row">
            <div class="preview-label">Registered Address</div>
            <div class="preview-value">
              {{ addressPreview('registeredAddress') }}
            </div>
          </div>
          <div class="preview-field full-row">
            <div class="preview-label">Trading Address</div>
            <div class="preview-value">
              {{ addressPreview('tradingAddress') }}
            </div>
          </div>
          <div class="preview-field">
            <div class="preview-label">Email</div>
            <div class="preview-value">
              {{ orgForm.get('email')?.value || '-' }}
            </div>
          </div>
          <div class="preview-field">
            <div class="preview-label">Phone</div>
            <div class="preview-value">
              {{ orgForm.get('phone')?.value || '-' }}
            </div>
          </div>
          <!-- MPS-263: whatever identifiers the chosen country asked for. -->
          <div class="preview-field">
            <div class="preview-label">Country of Incorporation</div>
            <div class="preview-value">{{ selectedCountryName || '-' }}</div>
          </div>
          <div class="preview-field" *ngFor="let field of identifierFields">
            <div class="preview-label">{{ field.label }}</div>
            <div class="preview-value">{{ identifierValues[field.key] || '-' }}</div>
          </div>
        </div>
      </div>

      <div class="preview-card">
        <div class="preview-card-title">
          <mat-icon>description</mat-icon>
          KYC Documents
        </div>
        <div class="preview-doc-list">
          <div class="preview-doc-row" *ngFor="let doc of documents">
            <div class="preview-doc-left">
              <mat-icon
                class="status-dot"
                [ngClass]="doc.fileUrl ? 'uploaded' : 'missing'"
              >
                {{ doc.fileUrl ? 'check_circle' : 'radio_button_unchecked' }}
              </mat-icon>
              {{ doc.label }}
              <span class="req" *ngIf="doc.required">*</span>
            </div>
            <div class="preview-doc-status">
              <span
                class="status-pill"
                [ngClass]="doc.fileUrl ? 'status-approved' : 'status-not-started'"
              >
                {{ doc.fileUrl ? 'Uploaded' : 'Not Uploaded' }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="preview-card">
        <div class="preview-card-title">
          <mat-icon>account_balance</mat-icon>
          Banking Information
        </div>
        <div class="preview-grid">
          <div class="preview-field">
            <div class="preview-label">Account Holder Name</div>
            <div class="preview-value">
              {{ bankForm.get('accountHolderName')?.value || '-' }}
            </div>
          </div>
          <div class="preview-field">
            <div class="preview-label">Account Number</div>
            <div class="preview-value">
              {{ bankForm.get('accountNumber')?.value || '-' }}
            </div>
          </div>
          <div class="preview-field">
            <div class="preview-label">IFSC / SWIFT Code</div>
            <div class="preview-value">
              {{ bankForm.get('ifscSwift')?.value || '-' }}
            </div>
          </div>
          <div class="preview-field">
            <div class="preview-label">Account Type</div>
            <div class="preview-value">
              {{ bankAccountTypeName(bankForm.get('accountTypeId')?.value) }}
            </div>
          </div>
        </div>
      </div>

      <!-- MPS-263 KYC-104 — a notice became a decision, because what is
           recorded is that a named person accepted this exact wording. -->
      <label class="declaration declaration--consent">
        <input type="checkbox" [(ngModel)]="consentAccepted"
               [ngModelOptions]="{ standalone: true }" />
        <div>
          <span class="declaration-text">{{ consentDeclaration.text }}</span>
          <small class="declaration-foot">{{ consentDeclaration.footnote }}</small>
          <small class="declaration-ver">Declaration version {{ consentDeclaration.version }}</small>
        </div>
      </label>
    </div>
  </div>

  <!-- Footer nav -->
  <div class="wizard-footer">
    <button
      class="btn btn-outline"
      (click)="goPrevTab()"
      [disabled]="activeTab === 'org'"
    >
      <mat-icon>chevron_left</mat-icon>
      Back
    </button>
    <button
      class="btn btn-primary"
      *ngIf="activeTab !== 'preview'"
      (click)="goNextTab()"
    >
      Next
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>
</div>
